import React from "react";

interface ISignalRTaskItemsContext {
  sendRefetchTaskItem: (taskItemGuid: string) => void;
  sendRefetchTeamTaskItems: () => void;
  sendRefetchUserTaskItems: () => void;
  onShouldRefetchTaskItem: (handler: (taskItemGuid: string) => void) => void;
  offShouldRefetchTaskItem: (handler: (taskItemGuid: string) => void) => void;
  onShouldRefetchTeamTaskItems: (handler: () => void) => void;
  offShouldRefetchTeamTaskItems: (handler: () => void) => void;
  onShouldRefetchUserTaskItems: (handler: () => void) => void;
  offShouldRefetchUserTaskItems: (handler: () => void) => void;
}

const SignalRTaskItemsContext = React.createContext<ISignalRTaskItemsContext>({
  sendRefetchTaskItem: () => null,
  sendRefetchTeamTaskItems: () => null,
  sendRefetchUserTaskItems: () => null,
  onShouldRefetchTaskItem: () => null,
  offShouldRefetchTaskItem: () => null,
  onShouldRefetchTeamTaskItems: () => null,
  offShouldRefetchTeamTaskItems: () => null,
  onShouldRefetchUserTaskItems: () => null,
  offShouldRefetchUserTaskItems: () => null,
});

export { SignalRTaskItemsContext };
